import { useBusinessCityQueryParams } from './queryParams/useBusinessCityQueryParams';
import { useBusinessOrgIdQueryParams } from './queryParams/useBusinessOrgIdQueryParams';
import { useExcludedBusinessesQueryParams } from './queryParams/useExcludedBusinessesQueryParams';
import { useGroupsQueryParams } from './queryParams/useGroupsQueryParams';
import { useIncludedBusinessesQueryParams } from './queryParams/useIncludedBusinessesQueryParams';
import { useOrgsQueryParams } from './queryParams/useOrgsQueryParams';
import { useSearchQueryParams } from './queryParams/useSearchQueryParams';

type FilterTuple = [string, (value: string | number | boolean | null) => void];

export const useGetBusinessModalFiltersState = () => {
    const { includedBusinesses, setIncludedBusinesses } = useIncludedBusinessesQueryParams();
    const { excludedBusinesses, setExcludedBusinesses } = useExcludedBusinessesQueryParams();
    const { groups, setGroups } = useGroupsQueryParams();
    const { org_id, setOrgId } = useOrgsQueryParams();
    const { business_org_id, setBusinessOrgId } = useBusinessOrgIdQueryParams();
    const { businessCity, setBusinessCity } = useBusinessCityQueryParams();
    const { search, setSearch } = useSearchQueryParams();

    return {
        business__in: [includedBusinesses, setIncludedBusinesses] as FilterTuple,
        business__notin: [excludedBusinesses, setExcludedBusinesses] as FilterTuple,
        groups: [groups, setGroups] as FilterTuple,
        org_id: [org_id, setOrgId] as FilterTuple,
        business_org_id: [business_org_id, setBusinessOrgId] as FilterTuple,
        city: [businessCity, setBusinessCity] as FilterTuple,
        query: [search, setSearch] as FilterTuple,
    };
};
